import { ProvidedServiceType } from '@/api/apis/case';
import { serviceTypeNames } from './constants';

const ADDITIONAL_SERVICES_LABEL = 'Additional Services';

export const getProvidedServicesText = (
  providedServiceTypes?: ProvidedServiceType[],
  hasAdditionalServices?: boolean,
): string => {
  const servicesList = providedServiceTypes?.map((t) => serviceTypeNames[t]) || [];

  if (hasAdditionalServices) {
    servicesList.push(ADDITIONAL_SERVICES_LABEL);
  }

  return servicesList.join(', ');
};
